import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleMediumFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const SacSectionContainer = styled.section(({ theme }) => ({
  paddingTop: "40px",
  paddingBottom: "40px",
  marginBottom: "0 !important",
  borderTop: `1px solid ${theme.color.line.medium}`,

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
    gap: "40px",
  },
}));

export const SacSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column-reverse",
  alignItems: "center",
  gap: "60px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

export const SacSectionBlock = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
}));

export const SacSectionBlockHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

export const SacSectionBlockTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleMediumFactory({ theme }),
}));

export const SacSectionBlockDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
}));

export const SacSectionBlockFooter = styled.footer(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
  },

  button: {
    justifyContent: "center",
    ...DefaultParagraphLargeFactory({ theme }),
  },
}));
